import { Component } from '@angular/core'
import { from, of, combineLatest } from 'rxjs'
import { Live } from '../../../lib/entity/live'
import { SubscribingHistory } from '../../../lib/entity/magazine'
import { LiveUserAuthority } from '../../../lib/entity/live-user-authority'
import { MagliveApiClient } from '../../../lib/api-client/maglive-api-client'
import {
  FirestoreAccess,
  ARCHIVE_PAGE_SIZE,
} from '../../../lib/firestore-access'
import { switchMap, filter } from 'rxjs/operators'
import { environment } from '../../../env/environment'

@Component({
  templateUrl: './index-page.component.html',
  styleUrls: ['./index-page.component.scss'],
})
export class IndexPageComponent {
  public baseURL = environment.baseURL
  authority: LiveUserAuthority | 'NOT_LOGIN'
  histories: SubscribingHistory[] = []
  broadcastingLives: Live[]
  reservedLives: Live[]
  archivedLives: Live[]
  userId: number
  allRead: Boolean
  isMaintenance: Boolean = false

  constructor(private firestoreAccess: FirestoreAccess) {
    MagliveApiClient.getAuthority()
      .pipe(
        switchMap((authorities) => {
          if (authorities.status === 503) {
            this.isMaintenance = true
          }
          const userId = authorities === 'NOT_LOGIN' ? null : authorities.userId
          this.userId = userId
          if (userId) {
            MagliveApiClient.getSubscribingHistories()
              .pipe(filter((x) => x !== 'NOT_AUTHORIZED' && x !== 'NOT_LOGIN'))
              .subscribe((x) => (this.histories = x as SubscribingHistory[]))
          }
          return combineLatest([
            of(authorities),
            firestoreAccess.archivedLives(userId, null),
            firestoreAccess.broadcastingLives(userId, null),
            firestoreAccess.reservedLives(userId, null),
          ])
        })
      )
      .subscribe((value) => {
        const [authorities, archivedLives, broadcastingLives, reservedLives] =
          value
        this.authority = authorities
        if (this.archivedLives === undefined) {
          this.archivedLives = archivedLives
          if (archivedLives.length < ARCHIVE_PAGE_SIZE) {
            this.allRead = true
          }
        }
        if (this.broadcastingLives === undefined) {
          this.broadcastingLives = broadcastingLives
        }
        if (this.reservedLives === undefined) {
          this.reservedLives = reservedLives
        }
      })
  }

  onScroll() {
    if (this.allRead) return
    const last = this.archivedLives[this.archivedLives.length - 1]
    from(
      this.firestoreAccess.archivedLives(
        this.userId,
        null,
        null,
        null,
        null,
        last
      )
    ).subscribe((lives) => {
      if (lives.length > 0) {
        this.archivedLives = this.archivedLives.concat(lives)
      } else {
        this.allRead = true
      }
    })
  }
}
